import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, TextField, Select } from '@fs/zion-ui'
import { v5 } from 'uuid'
import useRegisterKiosk from './hooks/useRegisterKiosk'
import DmcTemplePicker from '../../common/DmcTemplePicker'

export default function RegisterKioskOverlay({ onSuccess, dropdownOptions, ...overlay }) {
  const { t } = useTranslation()
  const { state, actions, submitOnClick } = useRegisterKiosk({ overlay, onSuccess })
  return (
    <DialogOverlay
      title={t('action.registerKiosk', 'Register Kiosk')}
      subtitle={t('kiosks.registerKioskConfirmation', 'Please enter the details to register the kiosk.')}
      {...overlay}
    >
      <DmcTemplePicker
        templeCode={state.templeCode}
        onSuggestionSelected={(selection) => actions.setTempleCode(selection?.templeCode)}
        onClear={() => actions.setTempleCode('')}
      />
      <Select
        id="addKioskLocationType"
        hidePlaceholder
        value={state.locationType}
        label={t('temple.kiosk.info.locationType', 'Location Type')}
        options={dropdownOptions('locationType')}
        onChange={(e) => {
          actions.setLocationType(e.target.value)
        }}
      />
      <TextField
        id="addKioskLocationDescription"
        name="locationDescription"
        label={t('temple.kiosk.info.locationDescription', 'Location Description')}
        value={state.locationDescription}
        onChange={(e) => actions.setLocationDescription(e.target.value)}
      />
      <Select
        id="addKioskLanguageCode"
        hidePlaceholder
        value={state.langCode}
        label={t('temple.kiosk.info.langCode', 'Language Code')}
        options={dropdownOptions('langCode')}
        onChange={(e) => actions.setLangCode(e.target.value)}
      />
      <TextField
        id="addKioskId"
        name="kioskId"
        label={t('temple.kiosk.info.kioskId', 'Kiosk ID')}
        value={state.kioskId}
        onChange={(e) => actions.setKioskId(e.target.value)}
        disabled={!!state.serialNumber}
      />
      <TextField
        id="addKioskSerialNumber"
        name="serialNumber"
        label={t('temple.kiosk.info.serialNumber', 'Serial Number')}
        value={state.serialNumber}
        onChange={(e) => {
          actions.setSerialNumber(e.target.value)
          actions.setKioskId(v5(e.target.value, 'cc7e07f9-52d6-4b47-ae90-04983bc4ce10'))
          if (e.target.value === '') {
            actions.setKioskId('')
          }
        }}
        disabled={!!state.kioskId && state.serialNumber === ''}
      />
      <DialogOverlayActions>
        <Button id="addKioskCancelButton" onClick={overlay.close}>
          {t('action.cancel', 'Cancel')}
        </Button>
        <Button
          id="addKioskSumitButton"
          onClick={submitOnClick}
          emphasis="high"
          disabled={
            !state.templeCode || !state.locationType || !state.locationDescription || !state.langCode || !state.kioskId
          }
        >
          {t('action.submit', 'Submit')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
